import SearchSaleOrderWeb from './SearchSaleOrderWeb'

export default SearchSaleOrderWeb
